import Ajax from '@/lib/ajax'

export default {
  /**
   * 创建/更新问卷
   */
  createQuestionnaire(obj: object) {
    let ajaxType = obj['id'] ? 'put' : 'post'
    return Ajax[ajaxType](`/api/MallConfigManagement/Questionnaire`, obj)
  },

  /**
   * 获取问卷详情
   * @param id 
   */
  getQuestionnaire(id: string) {
    return Ajax.get(`/api/MallConfigManagement/Questionnaire/${id}`)
  },

  /**
   * 查询指定问卷统计
   * @param id 
   */
  getQuestionnaireStatics(id: string) {
    return Ajax.get(`/api/MallConfigManagement/Questionnaire/Statics/${id}`)
  },

  /* 
    查询答卷详情
   */
  getQuestionnaireAnswer(id: string) {
    return Ajax.get(`/api/MallConfigManagement/Questionnaire/Answer/${id}`)
  }

}